export default __webpack_public_path__ + "static/media/partnership.7182994d.png";